import { Search, PenTool, Rocket, BarChart3, ArrowRight } from "lucide-react";

export const GrowthArchitectureDiagram = () => {
  const phases = [
    {
      icon: Search,
      title: "Diagnostic Audit",
      subtitle: "The Blueprint",
      description: "Forensic evaluation of growth infrastructure and AI-readiness using the MAHI Index™.",
      detail: "MAHI Index™",
    },
    {
      icon: PenTool,
      title: "Architecture Design",
      subtitle: "Strategic Planning",
      description: "Designing Perception Architectures and behavioral frameworks aligned to business goals.",
      detail: "Perception Architectures",
    },
    {
      icon: Rocket,
      title: "System Deployment",
      subtitle: "The Build",
      description: "90-day sprint deploying RAG-Enhanced Content engines and Automated Behavior Trees.",
      detail: "RAG + Behavior Trees",
    },
    {
      icon: BarChart3,
      title: "Systemic Monitoring",
      subtitle: "Ongoing Advisory",
      description: "Continuous optimization using the MAD-M™ Decay Model to prevent systemic entropy.",
      detail: "MAD-M™ Decay Model",
    },
  ];

  return (
    <section className="container mx-auto px-4 sm:px-6 py-12 sm:py-16">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-10">
          <p className="text-sm uppercase tracking-widest text-muted-foreground mb-3 font-medium">
            90-Day AI Growth Stack
          </p>
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold mb-4">
            Growth Architecture Deployment
          </h2>
          <p className="text-muted-foreground max-w-2xl mx-auto">
            A systematic approach from diagnostic audit through deployment and continuous optimization.
          </p>
        </div>

        {/* Desktop: horizontal flow */}
        <div className="hidden md:grid md:grid-cols-4 gap-4 items-start">
          {phases.map((phase, i) => {
            const Icon = phase.icon;
            return (
              <div key={phase.title} className="relative flex flex-col items-center text-center">
                {/* Arrow connector */}
                {i < phases.length - 1 && (
                  <div className="absolute top-10 -right-4 z-10 text-primary">
                    <ArrowRight className="w-5 h-5" />
                  </div>
                )}

                <div className="w-20 h-20 bg-gradient-to-br from-primary/15 to-accent/15 border-2 border-primary/30 flex items-center justify-center mb-4">
                  <Icon className="w-8 h-8 text-primary" />
                </div>

                <h3 className="font-bold text-base mb-1">{phase.title}</h3>
                <p className="text-xs text-primary font-medium mb-3">{phase.subtitle}</p>
                <p className="text-sm text-muted-foreground leading-relaxed mb-3">{phase.description}</p>
                <span className="inline-block px-3 py-1 text-xs font-semibold bg-primary/10 text-primary border border-primary/20">
                  {phase.detail}
                </span>
              </div>
            );
          })}
        </div>

        {/* Mobile: vertical flow */}
        <div className="md:hidden space-y-6">
          {phases.map((phase, i) => {
            const Icon = phase.icon;
            return (
              <div key={phase.title}>
                <div className="flex items-start gap-4">
                  <div className="shrink-0 w-14 h-14 bg-gradient-to-br from-primary/15 to-accent/15 border-2 border-primary/30 flex items-center justify-center">
                    <Icon className="w-6 h-6 text-primary" />
                  </div>
                  <div>
                    <h3 className="font-bold text-base mb-1">{phase.title}</h3>
                    <p className="text-xs text-primary font-medium mb-2">{phase.subtitle}</p>
                    <p className="text-sm text-muted-foreground leading-relaxed mb-2">{phase.description}</p>
                    <span className="inline-block px-3 py-1 text-xs font-semibold bg-primary/10 text-primary border border-primary/20">
                      {phase.detail}
                    </span>
                  </div>
                </div>
                {i < phases.length - 1 && (
                  <div className="ml-7 h-6 border-l-2 border-primary/20" />
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
